import SectionHeading from '../../components/ui/SectionHeading/SectionHeading.jsx';
import Card from '../../components/ui/Card/Card.jsx';
import Badge from '../../components/ui/Badge/Badge.jsx';
import CTASection from '../../components/home/CTASection/CTASection.jsx';
import styles from './Company.module.css';

const values = [
  { title: 'Clarity over cleverness', text: 'A design choice earns its place by making the product easier to understand, not by being unusual for its own sake.' },
  { title: 'Systems, not one-offs', text: 'We build every page from the same set of tokens and components, so quality compounds instead of resetting each time.' },
  { title: 'Ship, then refine', text: 'A page in front of real visitors teaches you more in a week than a month of internal review.' },
];

const timeline = [
  { year: '2023', text: 'Solvora starts as an internal template for a three-person product studio launching client MVPs.' },
  { year: '2024', text: 'The component system is rebuilt around shared design tokens after the third rebrand in a year.' },
  { year: '2025', text: 'Opened up as a public template, adopted by SaaS, fintech, and HealthTech teams for launch pages.' },
  { year: '2026', text: 'Insights CMS, Design System page, and full accessibility pass ship as part of the current release.' },
];

const team = [
  { name: 'Maya Ferrante', role: 'Head of Design' },
  { name: 'Devon Okafor', role: 'Design Systems Lead' },
  { name: 'Priya Nandan', role: 'Growth Lead' },
  { name: 'Sam Rourke', role: 'Engineering Lead' },
];

export default function Company() {
  return (
    <>
      <section className={styles.hero}>
        <div className="container">
          <Badge tone="secondary">Company</Badge>
          <h1 className={styles.title}>We build the page your product deserves</h1>
          <p className={styles.lead}>
            Solvora started as a way to stop rebuilding the same landing page from scratch for every
            client launch. It's now a system used by product teams who want their first impression
            to match the quality of what they've actually built.
          </p>
        </div>
      </section>

      <section className={styles.section}>
        <div className="container">
          <SectionHeading eyebrow="What we believe" title="Principles behind every page" />
          <div className={styles.valuesGrid}>
            {values.map((v) => (
              <Card key={v.title}>
                <h3 className={styles.cardTitle}>{v.title}</h3>
                <p className={styles.cardText}>{v.text}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className={styles.section}>
        <div className="container">
          <SectionHeading eyebrow="How we got here" title="A short history" />
          <div className={styles.timeline}>
            {timeline.map((t) => (
              <div key={t.year} className={styles.timelineRow}>
                <span className={styles.timelineYear}>{t.year}</span>
                <p className={styles.timelineText}>{t.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className={styles.section}>
        <div className="container">
          <SectionHeading eyebrow="Who's behind it" title="A small, focused team" />
          <div className={styles.team}>
            {/* ASSET SLOT: swap the initials avatar below for a real photo:
                <img src={`/src/assets/team/${slug}.jpg`} alt={m.name} className={styles.memberAvatar} />
                Recommended: square crop, ~200x200px. */}
            {team.map((m) => (
              <div key={m.name} className={styles.member}>
                <span className={styles.memberAvatar} aria-hidden="true">{m.name.charAt(0)}</span>
                <span className={styles.memberName}>{m.name}</span>
                <span className={styles.memberRole}>{m.role}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
